import React, { useEffect } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { createStore } from 'stores/eventOverviewStore';
import { requestEvent } from 'actions/inPersonTraining/eventOverview';
import Loading from 'components/shared/Loading';
import AssociatedContent from './AssociatedContent';
import Attendees from './Attendees';
import EventChangeManagement from './EventChangeManagement';
import Sessions from './Sessions';
import EventOverviewSidebar from './Sidebar';

const store = createStore();

function EventOverview({ match: { params } }) {
  const { eventId } = params;
  const dispatch = useDispatch();
  const loading = useSelector(state => state.loading);

  useEffect(() => {
    dispatch(requestEvent(eventId));
  }, [dispatch, eventId]);

  return (
    <Loading loading={loading}>
      <div className="PathBuilder">
        <EventChangeManagement />
        <div className="PathBuilder-main">
          <div className="PathViewer">
            <Sessions />
            <AssociatedContent />
            <Attendees />
          </div>
        </div>
        <div className="PathBuilder-side">
          <EventOverviewSidebar />
        </div>
      </div>
    </Loading>
  );
}

export default props => (
  <Provider store={store}>
    <EventOverview {...props} />
  </Provider>
);
